module.exports = __webpack_public_path__ + "1929ac66412c9834ef16d5803dc00ca2.png";